import { config } from 'api';
import errorHandler from 'utils/errorHandler';

const FEEDBACK_API_PATH = `${config.apiBasePath}/feedback`;
const FEEDBACK_OPTIONS_API_PATH = `${FEEDBACK_API_PATH}/issue-types`;

export const CLOSE_FEEDBACK_MODAL = 'CLOSE_FEEDBACK_MODAL';
export const SET_FEEDBACK_HAS_ERROR = 'SET_FEEDBACK_HAS_ERROR';
export const SET_FEEDBACK_OPTIONS = 'SET_FEEDBACK_OPTIONS';
export const SET_FEEDBACK_SENT = 'SET_FEEDBACK_SENT';
export const TOGGLE_FEEDBACK_POPUP = 'TOGGLE_FEEDBACK_POPUP';

export function closeModal() {
  return {
    type: CLOSE_FEEDBACK_MODAL,
  };
}
export function setFeedbackHasError() {
  return {
    type: SET_FEEDBACK_HAS_ERROR,
  };
}
export function setFeedbackOptions(data) {
  return {
    type: SET_FEEDBACK_OPTIONS,
    data,
  };
}
export function setFeedbackSent() {
  return {
    type: SET_FEEDBACK_SENT,
  };
}
export function toggleFeedbackPopup() {
  return {
    type: TOGGLE_FEEDBACK_POPUP,
  };
}

export const getFeedbackOptions = () =>
  (dispatch, getState, { network }) =>
    network.get(FEEDBACK_OPTIONS_API_PATH)
      .then(data => dispatch(setFeedbackOptions(data)))
      .catch(errorHandler);

export const sendPopupData = (params) =>
  (dispatch, getState, { network }) =>
    network.post(FEEDBACK_API_PATH, {
      body: JSON.stringify(params),
    })
      .then(() => {
        dispatch(setFeedbackSent());
      })
      .catch((response) => {
        dispatch(setFeedbackHasError());
        errorHandler(response);
      });
